import React, { useContext, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import moment from 'moment';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import Input from '../../NecttosComp/Input/Input';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { OLoading } from '../../static/svg/icons';
import Instruction from '../../Documentation/Instruction';

const getFieldDropDowns = (data) => async () => {
	const instance = await getAxiosTokenInstance();
	const resp = await instance.get('/college/library/getClassesLibrary', { params: { ...data } });
	if (resp.data.statusCode === 400) throw new Error(resp.data.message || 'API Error');
	return resp?.data?.classesData;
};

const getAllMembers = (data) => async () => {
	const { setLoading } = data;

	setLoading(true);

	try {
		if (!data.classId) throw new Error('ClassId Required');
		const instance = await getAxiosTokenInstance();
		const resp = await instance.get('/college/classes/getRollView', { params: { ...data } });
		if (resp.data.statusCode === 400) throw new Error(resp.data.message || 'API Error');
		return resp?.data?.classList;
	} finally {
		setLoading(false);
	}
};

export const RollView = ({ onClose }) => {
	const [loading, setLoading] = useState(false);
	const [state, setState] = useState({});
	const componentRef = useRef();
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const types = ['UG', 'PG'];
	const years = [2021, 2022, 2023, 2024, 2025];
	const [selectedType, setSelectedType] = useState('');
	const [selectedYear, setSelectedYear] = useState('');
	const { data = [] } = useQuery(['opacData', selectedType, selectedYear], getFieldDropDowns({ collegeId, selectedType, selectedYear }));
	const [selectedClassIds, setSelectedClassIds] = useState([]);

	console.log(selectedClassIds);

	const { data: allData = [], refetch } = useQuery(
		['members', state.classId, state.searchValue, state.date, state.studentType],
		() => {
			if (!state.classId && selectedClassIds.length === 0) {
				return Promise.resolve({});
			}
			return getAllMembers({
				collegeId: state.collegeId,
				classId: selectedClassIds.length > 1 ? selectedClassIds.join(',') : state.classId,
				date: state.date,
				classIdArray: selectedClassIds.length > 1 ? true : undefined,
				studentType: state.studentType,
				setLoading,
			})();
		},
		{ keepPreviousData: true },
	);

	const toggleClassSelection = (classId) => {
		setSelectedClassIds((prev) => {
			const newSelected = prev.includes(classId) ? prev.filter((id) => id !== classId) : [...prev, classId];
			if (newSelected.length === 0) {
				setState({});
			} else {
				setState((prevState) => ({
					...prevState,
					classId: newSelected.length === 1 ? newSelected[0] : prevState.classId,
				}));
			}
			return newSelected;
		});
	};

	const isAllSelected = selectedClassIds?.length === data?.length;
	const allMembers = allData.studentsRolles || [];
	const classData = allData.classData || {};
	const groupedData = allData.studentsRollesGroup || [];

	return (
		<Main title='Roll View' height='100%' width='100%'>
			<Header>
					<div className='flex items-center justify-between gap-1'>
						<Input width='150px' fieldName='Date' returnKey='date' state={state} setState={setState} type='date' />
						<Input width='200px' fieldName='Adtl. Info' returnKey='aditionalKey' state={state} setState={setState} options={['phoneNumber', 'secondLanguage', 'halticketNo', 'aparId', 'dob', 'dateOfAdmission', 'checkbox 1', 'checkbox 2', 'checkbox 3']} type='drop' />
						<Input
							width='150px'
							type='drop'
							fieldName='Student Type'
							returnKey='studentType'
							didntShowKey
							valueShowKey='label'
							optionDisplay='label'
							optionKey='value'
							state={state}
							setState={setState}
							options={[
								{ value: 'all', label: 'All' },
								{ value: 'onlyActive', label: 'Only Active' },
								{ value: 'tcOnly', label: 'TC Only' },
							]}
						/>
						<Input
							width='150px'
							type='drop'
							fieldName='Sort By'
							returnKey='sortBy'
							didntShowKey
							valueShowKey='label'
							optionDisplay='label'
							optionKey='value'
							state={state}
							setState={setState}
							options={[
								{ value: 'admissionNo', label: 'Admission No' },
								{ value: 'name', label: 'Name' },
								{ value: 'rollNo', label: 'Roll No' },
								{ value: 'secondLanguage', label: 'Second Language' },
							]}
						/>

						<div className='flex justify-end overflow-x-auto gap-2 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100'>
							{[...types, ...years].map((item) => {
								const isYear = typeof item === 'number';
								const isSelected = isYear ? selectedYear === item : selectedType === item;
								const handleClick = () => {
									isYear ? setSelectedYear(item) : setSelectedType(item);
									setSelectedClassIds([]);
								};

								return (
									<button key={item} onClick={handleClick} className={`whitespace-nowrap px-1 py-1 h-[40px] w-[60px] rounded-lg text-sm font-medium transition ${isSelected ? (isYear ? 'bg-green-500 text-white' : 'bg-blue-500 text-white') : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}>
										{item.toString().toUpperCase()}
									</button>
								);
							})}
						</div>
						
					</div>
									<div className='flex justify-end'>
										<Button type='fetch' onClick={refetch}>
							Reload
						</Button>
						<Instruction keyId={'rollView'}/>
						<Button type='print' tableRef={componentRef.current}>
							Print
						</Button>
						<Button type='close' onClick={onClose}>
							Close
						</Button>
				</div>
			</Header>
			<Body>
				<div style={{ width: '100%', display: 'flex', height: '100%' }}>
					<div className='w-[350px] shadow-md p-3 flex flex-col'>
						<div className='flex items-center bg-neutral-500 text-white dark:bg-neutral-700  px-2 py-1 text-sm'>
							<h6 className='w-[30%] text-center'>S.N.</h6>
							<h6 className='w-{70%} text-left'>Class Name</h6>
						</div>
						<div className='h-[700px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400  '>
							{data?.map((item, i) => (
								<div key={item.classId}>
									<div
										onClick={() => {
											toggleClassSelection(item.classId);
											setState({
												...state,
												classId: item.classId,
												className: item.className,
												collegeId: item.collegeId,
											});
											refetch();
										}}
										className={`flex items-center px-2 py-1 cursor-pointer hover:bg-gray-300 transition ${item.status !== 'active' ? 'bg-gray-100 dark:bg-neutral-400' : ''}`}>
										<input
											type='checkbox'
											className='mr-2'
											checked={selectedClassIds.includes(item.classId)}
											onChange={() => {
												setState({
													...state,
													classId: item.classId,
													className: item.className,
													collegeId: item.collegeId,
												});
												refetch();
											}}
										/>
										<h5 className='w-1/5 text-center text-sm text-black'>{i + 1}</h5>
										<h5 className='w-4/5 text-left text-sm text-black'>{item.className}</h5>
									</div>
									<div className='h-[1px] w-full bg-black text-white' />
								</div>
							))}
						</div>
					</div>
					<div ref={componentRef} className=' printable flex-grow ml-1 flex flex-col gap-4 overflow-y-auto h-full'>
						{Array.isArray(groupedData) && groupedData?.length > 0 ? (
							groupedData.map((x, sectionIndex) => (
								<div
									style={{
										flexGrow: 1,
										padding: '0 1%',
										position: 'relative',
									}}
									key={sectionIndex}>
									<div style={{ position: 'relative', pageBreakAfter: 'always' }}>
										<img
											src={selectedCollege?.logo}
											alt='College Watermark'
											style={{
												position: 'absolute',
												top: '50%',
												left: '50%',
												transform: 'translate(-50%, -50%)',
												width: 'auto',
												aspectRatio: '16/9',
												height: 'auto',
												maxWidth: 800,
												maxHeight: 600,
												opacity: 0.06,
												zIndex: 0,
												pointerEvents: 'none',
												objectFit: 'contain',
												height: 'auto',
											}}
										/>
										<div className='bg-slate-100 dark:bg-neutral-800 dark:text-white relative ' style={{ zIndex: 1 }}>
											<div style={{ display: 'flex', marginBottom: 20 }}>
												<img width='8%' height='5%' src={selectedCollege?.logo} />
												<div className=' w-[80%] justify-items-center'>
													<h2 className=' dark:text-white'>{selectedCollege?.collegeShortName}</h2>
													<p className=' dark:text-white'>{selectedCollege?.accreditedGrade}</p>
													<p className=' dark:text-white'>
														{selectedCollege?.address}, Phone: {selectedCollege?.phoneNumber}
													</p>
												</div>
											</div>
											{loading && <OLoading styles={{ height: 40, width: 40, size: 40 }} />}

											<div className='flex'>
												<h5 style={{ flexGrow: 1, textAlign: 'center' }}>{x?.className || classData?.className || 'class Name'}</h5>
											</div>

											<div style={{ display: 'flex', flexWrap: 'wrap' }}>
												{x.students &&
													[0, 1].map((sectionIndex) => {
														const totalStudents = x.students.length;
														const half = Math.ceil(totalStudents / 2);
														const sliceStart = sectionIndex * half;
														const sliceEnd = sliceStart + half;
														const sortedStudents = x.students.sort((a, b) => {
															if (state?.sortBy === 'admissionNo') {
																return a.admisionNo - b.admisionNo;
															} else if (state?.sortBy === 'name') {
																return a.name.localeCompare(b.name);
															} else if (state?.sortBy === 'rollNo') {
																return a.rollNo - b.rollNo;
															} else if (state?.sortBy === 'secondLanguage') {
																return a.secondLanguage.localeCompare(b.secondLanguage);
															}
															return 0;
														});
														const studentsSlice = sortedStudents.slice(sliceStart, sliceEnd);

														return (
															<div className=' overflow-y-show overflow-x-hidden w-[45%] bg-slate-100  dark:bg-neutral-800 dark:text-white' key={sectionIndex} style={{ margin: 10 }}>
																<div style={{ display: 'flex', backgroundColor: 'grey', height: 20, paddingTop: 2, marginBottom: 5, color: 'white' }}>
																	{['SN', 'Ad. No.', 'CN', 'G', 'Name', state?.aditionalKey?.toUpperCase().slice(0, 15) || 'Second Lan.'].map((label, i) => (
																		<h5
																			key={i}
																			style={{
																				textAlign: 'center',
																				fontSize: '12px',
																				textAlign: 'left',
																				width: ['5%', '14%', '6%', '7%', '40%'][i],
																				padding: 'auto',
																			}}>
																			{label}
																		</h5>
																	))}
																</div>

																{studentsSlice.map((item, i) => {
																	let key = state?.aditionalKey || 'secondLanguage';
																	let value = item?.[key];
																	let display = value;

																	if (!isNaN(new Date(value).getTime())) {
																		display = new Date(value).toDateString();
																	}
																	if (key === 'dob') {
																		display = moment(value).format('DD/MM/YYYY');
																	}
																	return (
																		<div key={i}>
																			<div style={{ marginTop: 3, marginBottom: -4, display: 'flex', backgroundColor: item.elective === 'Discountined' ? '#ff8f87' : undefined }}>
																				<h5 style={{ width: '3%', fontSize: 10, textAlign: 'center' }}>{sliceStart + i + 1}</h5>
																				<h5 style={{ width: '15%', fontSize: 11, textAlign: 'center' }}>{item?.admisionNo}</h5>
																				<h5 style={{ width: '5%', fontSize: 11, textAlign: 'center' }}>{item?.rollNo}</h5>
																				<h5 style={{ width: '7%', fontSize: 11, textAlign: 'center', color: 'red' }}>{item?.gender?.slice(0, 1)}</h5>
																				<h5 style={{ width: '40%', textWrap: 'wrap', fontSize: item.elective === 'Discountined' ? 10 : 12 }}>{item?.name?.toUpperCase()}</h5>
																				{state.aditionalKey?.includes('checkbox') ? Array.from({ length: parseInt(state.aditionalKey?.slice(8)) }, (_, index) => <index type='checkbox' key={index} style={{ width: 20, fontSize: 10, justifyContent: 'center', marginRight: 5 }} />) : <h5 style={{ width: 70, fontSize: 10, textAlign: 'center' }}>{display}</h5>}
																			</div>
																			<div style={{ height: 1, backgroundColor: 'black' }} />
																		</div>
																	);
																})}
															</div>
														);
													})}
											</div>

											<div style={{ display: 'flex', justifyContent: 'center', marginTop: 14 }}>
												<h5 className='text-sm text-center'>Printed on {moment().format('DD MMM YYYY hh:mm A')}</h5>
											</div>
										</div>
									</div>
								</div>
							))
						) : (
							<div
								style={{
									flexGrow: 1,
									padding: '0 1%',
									position: 'relative',
									backgroundColor: 'white',
								}}>
								<div style={{ position: 'relative', minHeight: 700, pageBreakAfter: 'always' }}>
									<img
										src={selectedCollege?.logo}
										alt='College Watermark'
										style={{
											position: 'absolute',
											top: '50%',
											left: '50%',
											transform: 'translate(-50%, -50%)',
											width: 'auto',
											aspectRatio: '16/9',
											height: 'auto',
											maxWidth: 800,
											maxHeight: 400,
											opacity: 0.06,
											zIndex: 0,
											pointerEvents: 'none',
											objectFit: 'contain',
										}}
									/>
									<div style={{ borderRadius: '25px', position: 'relative', zIndex: 1 }}>
										<div style={{ display: 'flex', marginBottom: 10 }}>
											<img width='8%' height='5%' src={selectedCollege?.logo} />
											<div style={{ width: '80%', textAlign: 'center' }}>
												<h2>{selectedCollege?.collegeShortName}</h2>
												<p>{selectedCollege?.accreditedGrade}</p>
												<p>
													{selectedCollege?.address}, Phone: {selectedCollege?.phoneNumber}
												</p>
											</div>
										</div>
										<div style={{ display: 'flex', marginBottom: 5 }}>
											<h5 className='w-60'></h5>
											<h5 style={{ flexGrow: 1, textAlign: 'center' }}>{classData?.className || 'class Name'}</h5>
											<h5 style={{ width: '200px' }}></h5>
										</div>
										<div style={{ display: 'flex', flexWrap: 'wrap' }}>
											{allMembers.students &&
												[...Array(Math.ceil(allMembers.students.length / 34)).keys()].map((_, sectionIndex) => {
													const slice = allMembers.students.slice(sectionIndex * 36, sectionIndex * 36 + 36);
													return (
														<div className='w-full max-h-[70vh] overflow-y-auto overflow-x-hidden' key={sectionIndex} style={{ width: '530px', margin: 10 }}>
															<div
																style={{
																	display: 'flex',
																	height: 30,
																	backgroundColor: 'grey',
																	marginBottom: 12,
																	color: 'white',
																}}>
																{['SN', 'Ad. No.', 'CN', 'Name', 'Lan', 'G'].map((label, i) => (
																	<h5
																		key={i}
																		style={{
																			color: 'white',
																			width: [53, 90, 53, 250, 50, 20][i],
																		}}>
																		{label}
																	</h5>
																))}
															</div>

															{slice.map((item, i) => (
																<div key={i}>
																	<div
																		style={{
																			display: 'flex',
																			height: 28,
																			backgroundColor: item.elective === 'Discountined' ? '#ff8f87' : undefined,
																		}}>
																		<h5 style={{ width: 53 }}>{sectionIndex * 36 + i + 1}</h5>
																		<h5 style={{ width: 90, fontSize: 12 }}>{item?.admisionNo}</h5>
																		<h5 style={{ width: 53 }}>{item?.rollNo}</h5>
																		<h5
																			style={{
																				width: 250,
																				fontSize: item.elective === 'Discountined' ? 12 : 16,
																			}}>
																			{item?.name?.toUpperCase()}
																		</h5>
																		<h5 style={{ width: 50, fontSize: 10 }}>{item?.secondLanguage?.slice(0, 3)}</h5>
																		<h5 style={{ width: 20, fontSize: 10 }}>{item?.gender?.slice(0, 1)}</h5>
																	</div>
																	<div style={{ height: 1, backgroundColor: 'black' }} />
																</div>
															))}
														</div>
													);
												})}
										</div>
										<div style={{ display: 'flex', justifyContent: 'center', marginTop: 18 }}>
											<h5 className='text-sm text-center font-thin'>Printed on {moment().format('DD MMM YYYY hh:mm A')}</h5>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</Body>
		</Main>
	);
};
